import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

import { Button } from '@/components/ui/button'
  import {Check, ChevronsUpDown} from 'lucide-vue-next'
  import {onMounted, ref} from 'vue'
  import { useForm } from 'vee-validate'
  import { toTypedSchema } from '@vee-validate/zod'
  import * as z from 'zod'
  import {
    Dialog, DialogClose,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
  } from '@/components/ui/dialog'
  import {
    Command,
    CommandEmpty,
    CommandGroup,
    CommandInput,
    CommandItem,
    CommandList,
  } from '@/components/ui/command'
  import {
    FormControl,
    FormField,
    FormItem,
    FormLabel,
    FormMessage,
  } from '@/components/ui/form'
  import {
    Popover,
    PopoverContent,
    PopoverTrigger,
  } from '@/components/ui/popover'
  import TablesService from "@/services/tables/tables.service";
  import {cn} from "@/utils/utils";
  import {i18n} from "@/utils/i18n";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ElementsModal',
  props: {
    open: { type: Boolean },
    setOpen: {}
  },
  emits: ['add'],
  setup(__props: any, { emit: __emit }) {

  const props = __props
  const emit = __emit
  const elementsOpen = ref(false);
  let elements: any = [];

  const formSchema = toTypedSchema(z.object({
    id: z.any(),
    code: z.string(),
    description: z.string()
  }))

  const { handleSubmit, setValues, values } = useForm({
    validationSchema: formSchema,
  })

  const onSubmit = handleSubmit((values) => {
    emit('add', values);
  })

  async function getElements() {
    const res = await TablesService.getData('coverage-elements')
    elements = res?.data
  }

  onMounted(async () => {
    await getElements();
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    open: props.open,
    "onUpdate:open": props.setOpen
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(DialogContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(DialogHeader), null, {
            default: _withCtx(() => [
              _createVNode(_unref(DialogTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('building.add_element')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("form", {
            class: "space-y-6",
            onSubmit: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args)))
          }, [
            _createVNode(_unref(FormField), { name: "element" }, {
              default: _withCtx(() => [
                _createVNode(_unref(FormItem), { class: "flex flex-col w-full" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(FormLabel), null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('column.coverage_element')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(Popover), {
                      open: elementsOpen.value,
                      "onUpdate:open": _cache[0] || (_cache[0] = ($event: any) => ((elementsOpen).value = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(PopoverTrigger), { "as-child": "" }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(FormControl), null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(Button), {
                                  variant: "outline",
                                  role: "combobox",
                                  class: _normalizeClass(_unref(cn)('w-full justify-between', !_unref(values).id && 'text-muted-foreground'))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(values).id ? _unref(elements).find(
                      (element) => element.id === _unref(values).id,
                  )?.code : _unref(i18n).global.t('table.select')) + " ", 1),
                                    _createVNode(_unref(ChevronsUpDown), { class: "ml-2 h-4 w-4 shrink-0 opacity-50" })
                                  ]),
                                  _: 1
                                }, 8, ["class"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(PopoverContent), { class: "w-[45vw] p-0" }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Command), null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(CommandInput), {
                                  placeholder: _ctx.$t('table.search')
                                }, null, 8, ["placeholder"]),
                                _createVNode(_unref(CommandEmpty), null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('table.no_result')), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(CommandList), null, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(CommandGroup), null, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(elements), (element) => {
                                          return (_openBlock(), _createBlock(_unref(CommandItem), {
                                            key: element.id,
                                            value: element.id,
                                            onSelect: () => {
                                _unref(setValues)({
                                  id: element.id,
                                  code: element.code,
                                  description: element.description
                                })
                                elementsOpen.value = false
                              }
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(Check), {
                                                class: _normalizeClass(_unref(cn)('mr-2 h-4 w-4', element.id === _unref(values).id ? 'opacity-100' : 'opacity-0'))
                                              }, null, 8, ["class"]),
                                              _createTextVNode(" " + _toDisplayString(element.code), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["value", "onSelect"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["open"]),
                    _createVNode(_unref(FormMessage))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(DialogFooter), null, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogClose), { "as-child": "" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Button), {
                      type: "button",
                      variant: "secondary"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('table.cancel')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Button), { type: "submit" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('table.confirm')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ], 32)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["open", "onUpdate:open"]))
}
}

})